<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li class="modelList_item" v-for="(model,index) in showList" v-bind:key="model.id">
                        <div class="modelList_thumbnails modelList_thumbnails_scene" v-bind:style="{'background-image' : 'url(\''+model.off_thumb+'?'+random+'\'),url(\'' + $global.MMD_URL + model.thumb+'\'),url(../../static/img/scene-default.png)'}" title="成套购买" v-if="model.thisSource=='3'" v-on:click="sceneDetail(model,index,true)">
                        <!-- sceneDetail(model.sceneId,index, model) -->
                            <div class="top_left tooltip-box top" data-content="成套模型" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #f5a726;">
                                <img src="../../static/img/model.png" alt="">
                            </div>
                            <span class="indexAPP"><i>{{index+1}}</i></span>
                        </div>
                        <div class="modelList_thumbnails modelList_thumbnails_scene" v-bind:style="{'background-image' : 'url(\''+model.off_thumb+'?'+random+'\'),url(\'' + model.thumbnailPath +'\'),url(../../static/img/skeb-default.png)'}" title="预览模型" v-if="model.thisSource=='4'" v-on:click="modelDetail(model,index,true,'')">
                        <!-- modelDetail(model.modelId,index,'',model) -->
                            <span class="indexAPP"><i>{{index+1}}</i></span>
                        </div>
                        <div class="modelList_thumbnails" v-bind:style="{'background-image' : 'url(\''+model.off_thumb+'?'+random+'\'),url(' + modelPath + model.modelId +'/' + model.version +'/screenshot.jpg)'}" v-on:click="modelDetail(model,index,true,'')" v-if="model.type!='Texture' && model.thisSource!='3' && model.thisSource!='4'" title="预览模型">
                            <div class="top_right" v-if="model.iHave">
                                <img src="../../static/img/ihave2.png" />
                            </div>
                            <span class="indexAPP"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightMsg(keyword)" v-for="(keyword) in model.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="modelList_thumbnails" v-bind:style="{'background-image':'url(\''+model.off_thumb+'?'+random+'\'),url(' + texturePath + model.modelId +'.' + model.ext +')'}" v-on:click="modelDetail(model,index,true,'')" v-if="model.type=='Texture' && model.thisSource!='3' && model.thisSource!='4'" title="预览贴图">
                            <div class="top_left tooltip-box top" data-content="免费贴图" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #1a8cd8;" v-if="model.thisSource=='0'">
                                <img src="../../static/img/texture.png"/>
                            </div>
                            <span class="indexAPP"><i>{{index+1}}</i></span>
                        </div>
                        <hr/>
                        <div class="modelList_info">
                            <div class="author_info">
                                <a class="tooltip-box top" v-if="model.thisSource!='4'" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src=" headImagePath + model.headImg" onerror="src='../../static/img/user-defalut.svg'"/>
                                </a>
                                <a class="tooltip-box top" v-if="model.thisSource=='4'" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src="model.headImg" onerror="src='../../static/img/user-defalut.svg'"/>
                                </a>
                                <span class="author_name no-effect" v-html="$options.filters.highLightMsg(model.name)" v-bind:title="model.name"  @dblclick="selectText($event)">{{model.name.length}}</span>
                                <!-- <span class="author_name" v-html="$options.filters.highLightMsg(model.name)" v-bind:title="model.name">{{model.name.length>10 ? model.name.substring(0, 10)+"..." : model.name}}</span> -->
                            </div>
                             <div class="model_info" v-if="model.thisSource=='4'">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="convertUTCTimeToLocalTime(model.createTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(model.viewCount)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="评论" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-comments fa-fw"></i>{{formatNumber(model.commentsCount)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="喜欢" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-star fa-fw"></i>{{formatNumber(model.likeCount)}}
                                </div>
                            </div>
                            <div class="model_info" v-if="model.thisSource!='4'">
                                <!-- <div class="scene_copy tooltip-box top" data-content="复制ID" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-on:mousedown="copySceneId(model.modelId)" v-if="model.thisSource=='0'">
                                    <i class="icon_sceneid"></i><input class="getSceneId" type="text" />
                                </div> -->
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="convertUTCTimeToLocalTime(model.createTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_seen tooltip-box top" data-content="资源大小" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="model.thisSource=='2'">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(model.resourceSize)}}
                                </div>
                                <div class="model_price tooltip-box top" data-content="模型售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-yen fa-fw"></i>{{formatNumber(model.price)}}
                                </div>
                                <div class="model_buy tooltip-box top" data-content="购买次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-shopping-cart fa-fw"></i>{{formatNumber(model.buyCount)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(model.viewCount)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" style="margin: 30px;font-size:18px;" v-if="modelListLoading">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&!modelListLoading">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage&&!modelListLoading" class="text_muted">已显示全部</h4>
			</div>
            <div id="list_info" class="modelList_infoShow_max" v-show="infoShow">
                <div id="info_top" class="info_top">
                    <span class="info_title">模型详情：{{message.name}}（{{index+1}}/{{modelListNum}}）</span>
                    <span class="zoom_window" v-on:click="zoomdiv" href="javascript:;"><img class="zoom_icon" src="../../static/img/最小化.png" alt="shrink"></span>
                    <span id="close_icon" class="layui-layer-setwin" v-on:click="closediv"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                </div>
                <div id="info_bottom" class="info_bottom_max">
                    <div id="info_left" class="info_left_max">
                        <span class="fullScreenClose" v-on:click="closediv"></span>
                        <div id="infoShow_div3d" class="show3DdivC_max" v-if="message.thisSource!='3'&& message.thisSource!='4'">
                            <div class="modelDetailLeft" @click="moveModelLeft()"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                            <div class="modelDetailRight" @click="moveModelRight()"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                            <!-- <iframe id="myframeC" v-if="infoShow"  class="myframe" src="https://www.thingjs.com/guide/sampleindex.html?m=5LiN55+l6YGT5Zyo5bmy5Zib/ModeViewSave_2.js" frameborder="0" style="width:100%;height:100%;display:none;"></iframe> -->
                            <iframe id="myframeC" v-if="infoShow"  class="myframe" src="https://www.thingjs.com/guide/sampleindex.html?m=295409/ModelViewSave_1.js" frameborder="0" style="width:100%;height:100%;display:none;"></iframe>
                        </div>
                        <div id="infoShow_div3d" class="show3DdivC_max" v-if="message.thisSource=='3'">
                            <div class="modelDetailLeft" @click="moveSceneLeft()"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                            <div class="modelDetailRight" @click="moveSceneRight()"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                            <iframe id="myframeC" v-if="infoShow" v-bind:src="sceneViewPath+'?uid='+ message.userId+'&sid='+message.sceneId" frameborder="0" style="width:100%;height:100%;"></iframe>
                        </div>
                        <span class="fullScreen" v-on:click="large()" v-if="message.thisSource=='3'"></span>
                        <div id="infoShow_div3d" style="position: relative;" class="show3DdivC_max" v-if="message.thisSource=='4'">
                            <div class="downloading" v-if='downloading'><span>模型正在排队下载中...</span><img src="../../static/img/downloading.gif" alt=""></div>
                            <!-- <div id="myframeC" v-if="infoShow&&!downloading"></div> -->
                            <!-- <iframe id="myframeC" v-if="infoShow&&!downloading" src="https://www.thingjs.com/guide/sampleindex.html?m=oLX7p0-6CEqQ7HcfFj_fAsH8FU4o/loadSketchfab.js" frameborder="0" style="width:100%;height:100%;"></iframe> -->
                            <iframe id="myframeC" v-if="infoShow&&!downloading" src="https://www.thingjs.com/guide/sampleindex.html?m=295409/loadSketchfab.js" frameborder="0" style="width:100%;height:100%;"></iframe>
                        </div>
                    </div>
                    <div id="info_right" class="info_right_max">
                        <div id="info_shop" class="info_shop" :style="message.thisSource=='4'?'width:216px;word-break: break-all;':''">
                            <div class="top_right" v-show="message.iHave">
                                <img src="../../static/img/ihave.png" />
                            </div>
                            <div class="priceTipBox" v-if="message.thisSource=='3'">购买需要<span>{{message.price}}</span>元</div>
                            <div class="priceTipBox" v-if="message.thisSource=='2'">购买需要<span>{{message.price}}</span>元</div>
                            <div class="saveTipBox" v-if="message.thisSource=='3'">（场景中包含收费模型{{message.modelNums}}个）</div>
                            <!-- <div class="saveTipBox" v-if="message.thisSource!='4'">（魔豆充值可享9折）</div> -->
                            <div class="shopDoneloadBox" v-if="message.thisSource=='3'"><button class="btn btn-shop"  @click.stop="checkCampany('buyScene',message)"><i class="fa fa-shopping-cart infoBuyIcon"></i>立即购买</button></div>
                            <div class="shopDoneloadBox" v-if="message.thisSource=='2'"><button class="btn btn-shop"  @click.stop="checkCampany('buyModel',message)"><i class="fa fa-shopping-cart infoBuyIcon"></i>立即购买</button></div>
                            <div class="shopDetailBox" v-if="message.thisSource!='4'">
                                <!-- <div id="shopDetail_left" class="shopDetailLeft floatLeft"><a href="javascript:void(0);" v-on:click="recharge"><img class="shopModou" src="../../static/img/modou.png" alt=""> 魔豆充值</a></div> -->
                                <!-- <div id="shopDetail_line" class="shopDetailLine floatLeft"></div> -->
                                <div class="shopDetailRight floatLeft">
                                    <span title="浏览量"><i class="fa fa-eye"></i>  {{formatNumber(message.viewCount)}}</span>
                                    <span title="销量" class="verticalBar" v-if="message.thisSource!='4'"><i class="fa fa-line-chart"></i> {{formatNumber(message.buyCount)}}</span>
                                </div>
                            </div>
                            <div class="shopDoneloadBox" v-if="message.thisSource=='4'"><button class="btn btn-shop"  @click.stop="selModel(message)"><i class="fa fa-cart-plus infoBuyIcon"></i>立即选用</button></div>
                            <div class="shopDetailBox" v-if="message.thisSource=='4'">
                                <!-- <div id="shopDetail_left" class="shopDetailLeft floatLeft"><a href="javascript:void(0);" v-on:click="recharge"><img class="shopModou" src="../../static/img/modou.png" alt=""> 魔豆充值</a></div> -->
                                <div id="shopDetail_line" class="shopDetailLine floatLeft"></div>
                                <div class="shopDetailRight floatLeft" style="width:90px">
                                    <span title="浏览量"><i class="fa fa-eye" style="margin-right: 5px;"></i>{{formatNumber(message.viewCount)}}</span>
                                </div>
                            </div>
                            <div class="shopLine"></div>
                            <div id="shopScenename_box" class="shopScenenameBox" v-if="message.thisSource!='4'">
                                <div class="top_left tooltip-box top nameBoxImg" data-content="官方收费" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="message.thisSource=='2'||message.thisSource=='3'||message.thisSource=='4'">
                                    <img src="../../static/img/model.png" />
                                </div>
                                {{message.name}}
                            </div>
                             <div id="shopScenename_box" class="shopScenenameBox" style="line-height:24px;text-align: justify;display: flex;" v-if="message.thisSource=='4'">
                                <div class="top_left tooltip-box top nameBoxImg nameBoxImgs1" data-content="sketchfab" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="message.thisSource=='2'||message.thisSource=='3'||message.thisSource=='4'">
                                    <img src="../../static/img/model.png" />
                                </div>
                                <span :title="message.name" style="width: calc(100% - 45px);margin-top: -2px;overflow: hidden;display: block;word-break: keep-all;text-overflow: ellipsis;white-space: nowrap;">{{message.name}}</span>
                            </div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='3'" style="display:flex;">场景id：<span style="cursor:pointer;width: auto !important;" title="双击复制" @dblclick="copyId()">{{message.sceneId}}</span></div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">类别：暂无</div>
                            <div class="shopDetailsBox" v-if="message.thisSource!='4'">上传时间：{{convertUTCTimeToLocalTime(message.createTime)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource!='4'">更新时间：{{convertUTCTimeToLocalTime(message.updateTime)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='4'">创建时间：{{convertUTCTimeToLocalTime(message.createTime)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='4'">上传时间：{{convertUTCTimeToLocalTime(message.updateTime)}}</div>
                            <div class="shopDetailsBox">作者：{{message.userName}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='4'">面数：{{message.faceCount}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='4'">顶点数：{{message.vertexCount}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='4'">模型大小：{{stringSize(message.size)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='3'">模型种类：{{message.modelCount}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='3'">贴图种类：{{message.textureCount}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='3'">对象/三角面/贴图：{{message.otherInfo}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='3'">描述：{{message.desc}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">版本号：{{message.version}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">尺寸：{{changeSize(message.length,message.width,message.height)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">格式：{{message.ext!='' ? changExt(message.ext):"gltf"}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">大小：{{formatBytes(message.resourceSize)}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'">三角面：{{modelFaces}}</div>
                            <div class="shopDetailsBox" v-if="message.thisSource=='2'"><i v-if="message.keyWordArr.length=='0'" style="font-style: normal;">标签：暂无</i>
                                <ul id='modelkeyword_ul' v-if="message.keyWordArr.length!='0'">
                                    <li class="modelkeyword" style="background:white;padding-left:0px;color:#999;">标签：</li>
                                    <li class="modelkeyword" v-for="(word) in message.keyWordArr" v-bind:key="word">{{word}}</li>
                                </ul>
                            </div>
                            <div class="shopLine" style="margin: 16px 6px 16px 16px;" v-if="message.thisSource=='4'"></div>
                            <div class="shopDetailsBox skb" v-if="message.thisSource=='4'" style="font-size: 16px;color: #000;">版权申明</div>
                            <div class="shopDetailsBox skb" style="padding-left: 36px;text-indent: -36px;" v-if="message.thisSource=='4'">版权：{{message.props.fullName}}</div>
                            <div class="shopDetailsBox skb" style="padding-left: 36px;text-indent: -36px;" v-if="message.thisSource=='4'">协议：{{message.props.url}}</div>
                            <!-- <div class="shopDetailsBox skb" style="padding-left: 36px;text-indent: -36px;" v-if="message.thisSource=='4'">类型：{{message.props.label}}</div> -->
                            <div class="shopDetailsBox skb" v-if="message.thisSource=='4'">注：本网站仅提供Sketchfab模型接入服务，请使用者遵守Sketchfab模型使用版权申明</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popContainer" v-show="infoShow"></div>
        <div id="boxHeader">
            <CamanyInfoService @hidePanel="hidePanel" v-show="panelShow" :panelShow="panelShow"></CamanyInfoService>
        </div>
    </div>
</template>

<script>
    import bus from '../assets/js/eventBus.js';
    import CamanyInfoService from './CampanyInfo.vue';
    import shield from '../assets/js/shield.js';
    var vm;
    var leftchangeFlag = true;
    var rightchangeFlag = true;
    export default {
        nanme:"modelList_box",
        components: {
            CamanyInfoService
        },
        data:function(){
            return{
                modelPath: "http://model.3dmomoda.com/models/",
				texturePath: "http://static.3dmomoda.com/textures/",
                headImagePath: "https://www.thingjs.com/",
                sceneViewPath: "https://www.thingjs.com/s/acf5297073561b74ca6cf934",
                DOWNMODELURL:"https://store.thingjs.com:8082/down/downSketchfabModels",
                PREVIEWPATH:"https://store.thingjs.com",
                sort_by:'viewCount',
                showList:[],
                queryData: {
					type:"charge",
					bigType: "",
					smallType: "",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe",
                    isAPP:false
                },
                isLastPage:false,
                message:[],
                modelFaces:'',
                modelKeyWord:'',
                infoShow:false,
                modelFreeUrl:'',
                index:0,
                fullscreen:false,
                iframeFlag:true,
                modelListNum:'',
                blower:null,
                nextQueryUrl:false,
                auth_token:'',
                downloading:false,
                sketchModelApp:'',
                modelListLoading:false,
                panelShow:false,
                changeShowList_SDK: ['模型'],
                random:1
            }
        },
        beforeCreate() {
            vm = this;
        },
        methods:{
            selectText(e){
                var e=e||window.event;
                e.stopPropagation();
                e.preventDefault();
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            copyId(){
                var id=$('.shopDetailsBox span').text();
                document.execCommand('copy');
                layer.msg('复制成功', {offset:['50%','47%']});
            },
            showTooltip: function(event) {
				var content = $(event.target).data("content");
				var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
				$(event.target).append(tipEle);
			},
			cancelTooltip: function(event) {
				$("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.modelList_info .author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.modelList_info .author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
			formatNumber: function(number) {
				if(number < 1000) {
					return number;
				} else {
					return(number / 1000).toFixed(1) + "k";
				}
            },
            loadMore: function() {
                if(this.modelListLoading) return;
                this.queryData.pageNumber++;
                if(this.$parent.$refs.Key.sketchModels) {
                    this.queryOtherModelList(this.queryData);
                } else {
                    this.queryModelList(this.queryData);
                }
			},
            queryModelList:function(data){
                var _this = this;
                 _this.modelListLoading=true;
                var _list = this.showList;
                data.type='charge';
                // data.type=(data.type=='charge'||'free');
                this.queryData.type= data.type;
				this.$reqs.post("/model/queryModels", data).then(function(result) {
                    if(result.data && result.data.state) {
                        var content = result.data.content.list;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',result.data.content.totalRow);
                        _this.modelListNum = result.data.content.totalRow;
                        for(var i = 0; i < contentLen; i++) {
                            _list.push(content[i]);
                        }
                        _this.isLastPage = result.data.content.totalPage <= result.data.content.pageNumber;
                    }else{
                       console.log('queryModelList error'+error);
                    }
                    _this.modelListLoading=false;
                }).catch(function(error) {
                    console.log('queryModelList error'+error);
                    _this.modelListLoading=false;
                });
            },
            formatBytes:function(bytes, decimals) {
                if (bytes === 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            queryOtherModelList:function(data){
                var _this = this;
                _this.modelListLoading = true;
                var _list = this.showList;
                this.$reqs.post("/model/queryOtherModels", data).then(function(result) {
                    if(result.data && result.data.state) {
                        var content = result.data.content.list;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',content[0].row);
                        _this.modelListNum = content[0].row;
                        for(var i = 0; i < contentLen; i++) {
                            content[i].thisSource = '4';
                            content[i].headImg = 'https://store.thingjs.com/avatars/' + content[i].userId + '.jpeg';
                            content[i].thumbnailPath = 'https://store.thingjs.com/thumbnail/' + content[i].modelId + '.jpeg';
                            content[i].isSketchfabModel=true;
                            content[i].createTime =content[i].orginTime;
                            _list.push(content[i]);
                        }
                        _this.isLastPage = false;
                    }else{
                       console.log('queryOtherModels error'+error);
                    }
                    _this.modelListLoading = false;
                }).catch(function(error) {
                    console.log('queryOtherModels error'+error);
                    _this.modelListLoading = false;
                });
            },
            sceneDetail:function(model,index,flag){
                if(flag){
                    model.index = index;
                    var msg = {title:'查看模型',subject:'viewBulkModel',toolInfo:{data:model}};
                    bus.$emit('view',msg);
                    return
                }
                var _this = this
                if (model) {
                    var len = _this.changeShowList_SDK.length
                    var sdkObj = {
                        resources: this.changeShowList_SDK[0],
                        type: len == 1 ? '全部' :_this.changeShowList_SDK[1],
                        projectName: model.name,
                        projectID: model.sceneId + ''
                    }
                    len == 2 ? sdkObj['BigType'] = '全部' :  sdkObj['BigType'] = _this.changeShowList_SDK[2]
                    window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', sdkObj)
                }
                if($.cookie('openid')){
                    var _this = this;
                    _this.index = index;
                    this.$reqs.get("model/queryOneScenes", {
                        params: {
                            id: model.sceneId
                        }
                    }).then(function(result){
                        if($('.zoom_icon').alt == "shrink"||$('.zoom_icon').alt == null){
                            $('body').addClass('overflowhide');
                            // $("body").parent().css("overflow-y","hidden");
                            $('.kefuBtn').hide();
                            $('.qqBtn').hide();
                            $('.wxBtn').hide();
                        }
                        if(result.data && result.data.state) {
                            _this.message = result.data.content[0];
                            var container = '';
                            _this.infoShow = true;
                            $('body').addClass('overflowhide');
                            container='infoShow_div3d';
                        }
                    })
                }else{
                   logoinForStore();
                }
            },
            modelDetail:function(valSDK,index,flag,val){
                if(flag){
                    valSDK.index = index;
                    valSDK.val = val;
                    var msg = {title:'查看模型',subject:'viewModel',toolInfo:{data:valSDK}};
                    bus.$emit('view',msg);
                    return
                }
                var _this = this
                if (val === '') {
                        var len = _this.changeShowList_SDK.length
                        var sdkObj = {
                            resources: this.changeShowList_SDK[0],
                            type: len == 1 ? '全部' :_this.changeShowList_SDK[1],
                            projectName: valSDK.name,
                            projectID: valSDK.modelId
                        }
                        // console.log(valSDK, 'va;sdk')
                        len == 2 ? sdkObj['BigType'] = '全部' :  sdkObj['BigType'] = _this.changeShowList_SDK[2]
                        window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', sdkObj)
                }
                if($.cookie('openid')){
                    var _this = this;
                    _this.index = index;
                    _this.downloading=false;
                    // 点击sketch模型
                    if (_this.$parent.$refs.Key.sketchModels) {
                        if (_this.$parent.$refs.header.isSketchfab||$.cookie('sketchUser')=='true') {
                            // if(!_this.$parent.$refs.header.para.access_token&&sessionStorage.sketchUser) {
                            //     if (typeof(_this.$parent.$parent.$refs.header) != undefined){
                            //         _this.$parent.$parent.$refs.header.para=JSON.parse(sessionStorage.sketchUser);
                            //     }
                            // }
                            // 检测到用户是否在ThingJS网站建立Sketchfab账号
                            this.$reqs.post('model/exitModels',{uid:valSDK.modelId}).then(res=> {
                                _this.message.size='';
                                if(res.data.state) {//模型已下载
                                    var thumbnailPath=val.thumbnailPath;
                                    var updateTime=res.data.content.createTime;
                                    var viewCount=val.viewCount;
                                    var faceCount=res.data.content.faceCount||val.faceCount;
                                    var vertexCount=res.data.content.vertexCount||val.vertexCount;
                                    _this.message = res.data.content;
                                    _this.message.userName = val.userName;
                                    _this.message.createTime=val.createTime;
                                    _this.message.updateTime=updateTime;
                                    _this.message.viewCount=viewCount;
                                    _this.message.thumbnailPath=thumbnailPath;
                                    _this.message.faceCount=faceCount;
                                    _this.message.vertexCount=vertexCount;
                                    _this.message.thisSource = '4';
                                    _this.message.props=JSON.parse(res.data.content.license);
                                    var container = '';
                                    container='infoShow_div3d';
                                    _this.previwSketchModel(_this.message);
                                } else {
                                    _this.downloading=true;
                                    _this.message=val;
                                    _this.message.updateTime='暂无';
                                    _this.message.props=val.license;
                                    _this.downModel(valSDK.modelId,val);
                                }
                                _this.infoShow = true;
                                $('body').addClass('overflowhide');
                            }).catch(err=>{
                                console.log(err);
                            })
                            return;
                        } else {
                            _this.$parent.$refs.header.writeMsg(valSDK.modelId,index,val,_this);
                            _this.infoShow = false;
                            $('body').removeClass('overflowhide');
                            return;
                        }
                    }
                    // _this.infoShow = true;
                    // $('body').addClass('overflowhide');
                    this.$reqs.get("model/queryOneModels", {
                        params: {
                            id: valSDK.modelId
                        }
                    }).then(function(result) {
                        if($('.zoom_icon').alt == "shrink"||$('.zoom_icon').alt == null){
                            // $("body").parent().css("overflow-y","hidden");
                            $('body').addClass('overflowhide');
                            $('.kefuBtn').hide();
                            $('.qqBtn').hide();
                            $('.wxBtn').hide();
                        }
                        if(result.data && result.data.state) {
                            _this.message = result.data.content[0];
                            var container = '';
                            if(result.data.content[0].type != "Texture"){
                                _this.infoShow = true;
                                $('body').addClass('overflowhide');
                            }else{
                                _this.infoShow = false;
                                layer.msg('当前模型暂不支持预览',{time: 1000});
                                $('body').removeClass('overflowhide');
                            }
                            container='infoShow_div3d';
                            setTimeout(function(){
                                $(".filler_wrapper .filler").width("80%");
                                $(".filler_wrapper .value").text("80%");
                            },50);

                            if(result.data.content[0].type != "Texture") {
                                var url3d = 'https://model.3dmomoda.com/models/' + result.data.content[0].modelId + "/0/gltf/";
                                _this.modelFreeUrl = url3d;
                                $(document).ready(function(e){
                                    var iframe = document.getElementById("myframeC");
                                    if (iframe.attachEvent) {
                                        if(_this.iframeFlag){
                                            iframe.attachEvent("onload", function() {
                                                _this.iframeFlag = false;
                                                setTimeout(function(){
                                                    _this.callFuncInThingJS('init',_this.modelFreeUrl);
                                                },1000);
                                            });
                                        }else{
                                            _this.callFuncInThingJS('showModel',_this.modelFreeUrl);
                                        }
                                    } else {
                                        if(_this.iframeFlag){
                                            iframe.onload = function() {
                                                _this.iframeFlag = false;
                                                setTimeout(function(){
                                                    _this.callFuncInThingJS('init',_this.modelFreeUrl);
                                                },1000);
                                            };
                                        }else{
                                            _this.callFuncInThingJS('showModel',_this.modelFreeUrl);
                                        }
                                    }
                                })
                                $.ajax({
                                    url: _this.modelFreeUrl+'index.json',
                                    type:'get',
                                    dataType:'json',
                                    success:function(data,textStatus){
                                        if(textStatus=="success"){
                                            if(data.faces){
                                                _this.modelFaces=data.faces+'面';
                                            }else{
                                                _this.modelFaces='计算中';
                                            }
                                        }else{
                                            _this.modelFaces='计算中';
                                        }
                                    },
                                    error:function(xhr,textStatus){
                                        _this.modelFaces='计算中';
                                    }
                                });
                            } else {
                                _this.modelFreeUrl = _this.texturePath + result.data.content[0].modelId + "." + result.data.content[0].ext;
                                var di = "#" + container;
                                // $(di).css({
                                //     "background": "#eaeaea url(" + _this.modelFreeUrl + ")",
                                //     "background-repeat": "no-repeat",
                                //     "background-size": "90% auto ",
                                //     "background-position": "center"
                                // });
                            }
                        }
                    });
                }else{
                    logoinForStore();
                }
            },
            previwSketchModel(obj) {
                var _this=this;
                // 预览地址
                var url=_this.PREVIEWPATH+obj.model_url+'/scene.gltf';
                _this.modelFreeUrl = url;
                $(document).ready(function(e){
                    var iframe = document.getElementById("myframeC");
                    if (iframe.attachEvent) {
                        if(_this.iframeFlag){
                            iframe.attachEvent("onload", function() {
                                _this.iframeFlag = false;
                                setTimeout(function(){
                                    _this.callFuncInThingJS('init',_this.modelFreeUrl);
                                },1000);
                            });
                        }else{
                            _this.callFuncInThingJS('showModel',_this.modelFreeUrl);
                        }
                    } else {
                        if(_this.iframeFlag){
                            iframe.onload = function() {
                                _this.iframeFlag = false;
                                setTimeout(function(){
                                    _this.callFuncInThingJS('init',_this.modelFreeUrl);
                                },1000);
                            };
                        }else{
                            _this.callFuncInThingJS('showModel',_this.modelFreeUrl);
                        }
                    }
                })
            },
            recharge:function(){
                var index = layer.open({
                    type: 2,
                    move: false,
                    title: false,
                    closeBtn: 0,
                    area: ['535px', '416px'],
                    resize: false,
                    content:['https://www.thingjs.com/static/payment/createPay/payRecharge.html?userId='+$.cookie('mmdId'), 'no'],
                    skin: 'buyRecharge',
                    success:function(){
                        document.getElementsByClassName('buyRecharge')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');
                    }
                });
                window. addEventListener ('message', function(event) {
                    if(event.data&&event.data.type&&event.data.type=="newStyle") {
                        $(".buyRecharge").css({'border-radius':'8px','backgroundColor':'rgba(0,0,0,0)'});
                        $(".buyRecharge iframe").css({'border-radius':'8px','backgroundColor':'rgba(0,0,0,0)'});
                    }
                    if(event.data=='closeRecharge'){
                        layer.close(index);
                    }
                });
            },
            convertUTCTimeToLocalTime: function(UTCDateString) {
				if(!UTCDateString) {
					return this.message.createTime;
				}
				function formatFunc(str) {
					return str > 9 ? str : '0' + str
				}
                var date2 = new Date(UTCDateString);
                if(date2=='Invalid Date') return UTCDateString;
				var year = date2.getFullYear();
				var mon = formatFunc(date2.getMonth() + 1);
				var day = formatFunc(date2.getDate());
				var hour = date2.getHours();
				var sec = date2.getSeconds();
				hour = formatFunc(hour);
				sec = formatFunc(sec);
				var min = formatFunc(date2.getMinutes());
				var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
				return dateStr;
            },
			changExt: function(geshi) {
				if(geshi == null) {
					var format = "gltf";
				} else {
					var format = this.message.ext;
				}
				return format;
            },
            copySceneId:function(modelid){
                var _this=this;
				$(".getSceneId").val("");
				$(".getSceneId").val(modelid);
				$(".getSceneId").select();
				document.execCommand("Copy");
				if(!_this.win && !_this.mac && !_this.xll) {
					layer.msg("模型ID已复制！",{time: 1000});
				}else{
					layer.msg("模型ID已复制！",{time: 1000});
				}
            },
			changeSize: function(l, w, h) {
				var ll = Number(l).toFixed(2);
				var ww = Number(w).toFixed(2);
				var hh = Number(h).toFixed(2);
				var sizes = ll + 'm x ' + ww + 'm x ' + hh + 'm';
				return(sizes);
            },
            stringSize:function(size) {
                if(size==''||size==undefined) return '未知';
                var size=parseInt(Number(size/1024/1024))>0?(Number(size/1024/1024)).toFixed(2)+'MB':(Number(size/1024)).toFixed(2)+'KB';
                return size;
            },
            buymodel:function(model){
                var _this = this;
                if($.cookie('openid')){
                    if(model.iHave){
                        layer.confirm('您已购买过该模型，确认还要重复购买吗？', {
                            btn: ['确认','退出']
                        }, function(index){
                            _this.goBuyModel(model);
                            layer.close(index);
                        }, function(){});
                    }else{
                       _this.goBuyModel(model);
                    }
                }else{
                    logoinForStore();
                }
            },
            selModel:function(model){
                var _this = this;
                if($.cookie('openid')){
                    if(_this.downloading) {
                        _this.$Modal.info({
                            title: '温馨提示',
                            content:"<div class='infoMain' style='min-height:100px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:3px'>模型排队下载中，请下载完成后选用！<label class='info-bolder'></span></p></div>",
                            okText: '关闭',
                            closable:true,
                            width:370,
                        });
                        return;
                    }
                    var userId=$.cookie('mmdId');
                    var modelId=model.modelId;
                    var imgurl=model.thumbnailPath;
                    var modelName=model.name;
                    var modelUrl='https://store.thingjs.com'+model.model_url+'/scene.gltf';
                    let isMmdidLegitimate;
                    try{
                        isMmdidLegitimate = this.$global.AntiSqlValid(userId);
                    }catch(e){
                        isMmdidLegitimate = true;
                    }
                    if(isMmdidLegitimate){
                        _this.$reqs.get("/model/querySketchModelsForUser", {params:{uid:userId,modelId:modelId}}).then(res=>{
                            if(res.data.content.length) {
                                // 模型已选用
                                _this.$Modal.info({
                                    title: '温馨提示',
                                    content:"<div class='infoMain' style='min-height:121.5px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:0'>该模型已选用！您可在“在线开发-个人-Skfb”目录中使用。<label class='info-bolder'></span></p></div>",
                                    okText: '关闭',
                                    closable:true,
                                    width:405,
                                });
                            } else {
                                // 选用模型
                                _this.selSketchModel(userId,modelId,modelName,imgurl,modelUrl,model);
                            }
                        }).catch(err=>{
                            console.log(err)
                        })
                    }
                }else{
                    logoinForStore();
                }
            },
            selSketchModel:function(userId,modelId,modelName,image,modelUrl,val) {
                var _this=this;
                let para={
                    userId:userId,
                    modelId:modelId,
                    modelName:modelName,
                    image:image,
                    modelUrl:modelUrl,
                    type:val.type,
                    license:val.props,
                    username:val.userName,
                    faceCount:val.faceCount,
                    size:val.size,
                    vertexCount:val.vertexCount
                };
                _this.$reqs.post("/model/addSketchModelsForUser", para).then(res=>{
                    // console.log(res.data);
                    if(res.data.state) {
                        _this.$Modal.info({
                            title: '温馨提示',
                            content:"<div class='infoMain' style='min-height:121.5px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:0px;'>Sketchfab模型选用成功！相应模型已复制到在线开发“模型-个人-Skfb”目录。<label class='info-bolder'></span></p></div>",
                            okText: '关闭',
                            closable:true,
                            width:405,
                        });
                    } else {
                        _this.$Modal.info({
                            title: '温馨提示',
                            content:"<div class='infoMain' style='min-height:86px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span>"+res.data.content+"！<label class='info-bolder'></span></p></div>",
                            okText: '关闭',
                            closable:true,
                            width:315,
                        });
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            buyscene:function(scene){
                var _this = this;
                if($.cookie('openid')){
                    var userId =$.cookie('mmdId');
                    var imgurl = _this.$global.MMD_URL + scene.thumb;
                    var dataArr = {
                        'title':'购买成套模型',
                        'imgsrc': imgurl,
                        'describe':'<span class="_title">购买成套模型：</span><br><br><span ng-show="!publicPay">付款后，您将获得此场景的副本，同时您还可在CamBuilder客户端的【右侧模型列表-个人-已购买的模型】和ThingJS在线开发环境的【资源-模型资源-左上菜单-我的】中找到模型并使用。</span><span ng-show="publicPay">请在对公付款后及时与平台客服联系。谢谢！</span>',
                        'price':scene.price,
                        'id':userId,
                        'modelId':'',
                        'sceneId':scene.sceneId,
                        'email':'',
                        'type':'bulkModel',
                        'step':scene.step,
                        'paySource': window.location.href,
                    }
                    layer.open({
                        type: 2,
                        title: false,
                        closeBtn: 0,
                        area: ['585px', '568px'],
                        // content: ['http://127.0.0.1/guide/createPay/payment.html?type=bulkModel&userId='+userId,'no'],
                        content: ['https://www.thingjs.com/static/payment/createPay/payment.html?type=bulkModel&userId='+userId,'no'],
                        skin: 'buyModelDiv',
                        success:function(){
                            document.getElementsByClassName('buyModelDiv')[0].children[1].children[0].contentWindow.postMessage(dataArr,'*');
                            scene.step = '';
                        }
                    });
                    window.addEventListener('message',function(event){
                        if(event.data&&event.data.type&&event.data.type=="newStyle") {
                            $(".buyModelDiv").css({"border-radius":"8px","background-color": "transparent"});
                            $(".buyModelDiv iframe").css("border-radius","8px");
                        }
                        if(event.data=='close'){
                            layer.closeAll();
                            this.step = '';
                        }
                        if(event.data=='success'){
                            layer.closeAll();
                            $('#layui-layer').hide();
                            $('#layui-layer1').hide();
                            $('.shadowpage').hide();
                            $('.shadowpage1').hide();
                            $('.pc-container3d').hide();
                            _this.$layer.closeAll("iframe");
                            _this.message.iHave = true;
                            // _this.$Modal.info({
                            //     title: '温馨提示',
                            //     content:"<div class='infoMain' style='min-height:112px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:0'>购买成功，稍后您将在CamBuilder客户端中看到该场景的副本，同时您还可在CamBuilder客户端的模型列表和ThingJS在线开发环境中资源项模型资源找到模型并使用。<label class='info-bolder'></span></p></div>",
                            //     okText: '关闭',
                            //     closable:true,
                            //     width:418.5,
                            // });
                            window.AnalysysAgent && window.AnalysysAgent.track('source_pay_success',{
                               'buyPackageName': dataArr.title
                           })
                        }
                    });
                }else{
                    logoinForStore();
                }
            },
            goBuyModel:function(model){
                var _this = this;
                var userId =$.cookie('mmdId');
                var imgurl = this.modelPath + model.modelId +'/' + model.version +'/screenshot.jpg';
                var dataArr = {
                    'title':'购买模型',
                    'imgsrc': imgurl,
                    'describe':'<span class="_title">购买模型：'+model.name+'</span><br><br><span ng-show="!publicPay">付款后，您可在CampusBuilder（模模搭）客户端的【右侧模型列表-个人-已购买的模型】和ThingJS在线开发环境的【资源-模型资源-左上菜单-我的】中找到并使用。</span><span ng-show="publicPay">请在对公付款后及时与平台客服联系。谢谢！</span>',
                    'price':model.price,
                    'id':userId,
                    'modelId':model.modelId,
                    'sceneId':'',
                    'type':'buyModel',
                    'step':model.step,
                    'paySource': window.location.href,
                }
                layer.open({
                    type: 2,
                    title: false,
                    closeBtn: 0,
                    area: ['585px', '568px'],
                    // content: ['http://127.0.0.1/guide/createPay/payment.html?type=buyModel&userId='+userId,'no'],
                    content: ['https://www.thingjs.com/static/payment/createPay/payment.html?type=buyModel&userId='+userId,'no'],
                    skin: 'buyModelDiv',
                    success:function(){
                        document.getElementsByClassName('buyModelDiv')[0].children[1].children[0].contentWindow.postMessage(dataArr,'*');
                        model.step = '';
                    }
                });
                window.addEventListener('message',function(event){
                    if(event.data&&event.data.type&&event.data.type=="newStyle") {
                        $(".buyModelDiv").css({"border-radius":"8px","background-color": "transparent"});
                        $(".buyModelDiv iframe").css("border-radius","8px");
                    }
                    if(event.data=='close'){
                        layer.closeAll();
                    }
                    if(event.data=='success'){
                        layer.closeAll();
                        $('#layui-layer').hide();
                        $('#layui-layer1').hide();
                        $('.shadowpage').hide();
                        $('.shadowpage1').hide();
                        $('.pc-container3d').hide();
                        _this.$layer.closeAll("iframe");
                        _this.message.iHave = true;
                        _this.changeModelState(model.modelId);
                        window.AnalysysAgent && window.AnalysysAgent.track('source_pay_success',{
                            'buyPackageName': dataArr.title,
                            'name': model.name,
                            'modelId':model.modelId
                        })
                    }
                });
            },
            changeModelState:function(modelId){
                var list = this.showList;
                for(var i=0;i<list.length;i++){
                    if(list[i].modelId==modelId){
                        list[i].iHave = true;
                    }
                }
            },
            zoomdiv:function(){
                let zoomicon = document.getElementsByClassName('zoom_icon')[0];
                let listInfo = document.getElementById('list_info');
                let infoBottom = document.getElementById('info_bottom');
                let infoLeft = document.getElementById('info_left');
                let infoShowDiv3d = document.getElementById('infoShow_div3d');
                let infoRight = document.getElementById('info_right');
                if($(".fullScreen").hasClass("tuichu")){-
                    $("#list_info").removeClass("quanping");
                    $("#myframeC").removeClass("fullFrame");
                    $(".fullScreen").removeClass("tuichu");
                    // $("html").css("overflow-y","scroll");
                    $(".popContainer").show();
                    // $('.navHeader').hide();
                    $(".fullScreenClose").hide();
                    if(zoomicon.alt == "maximize"){
                        $('.kefuBtn').show();
                        $('.qqBtn').show();
                        $('.wxBtn').show();
                    }
                }
                if(zoomicon.alt == "shrink"){
                    listInfo.className = 'modelList_infoShow';
                    infoBottom.className = 'info_bottom';
                    infoLeft.className = 'info_left';
                    infoShowDiv3d.className = 'show3DdivC';
                    infoRight.className = 'info_right';
                    $('.kefuBtn').show();
                    $('.qqBtn').show();
                    $('.wxBtn').show();
                    zoomicon.src = "../../static/img/最大化.png";
                    zoomicon.alt = "maximize";
                    // $("body").parent().css("overflow-y","auto");

                }else if(zoomicon.alt == "maximize"){
                    listInfo.className = 'modelList_infoShow_max';
                    infoBottom.className = 'info_bottom_max';
                    infoLeft.className = 'info_left_max';
                    infoShowDiv3d.className = 'show3DdivC_max';
                    infoRight.className = 'info_right_max';
                    $('.kefuBtn').hide();
                    $('.qqBtn').hide();
                    $('.wxBtn').hide();
                    zoomicon.src = "../../static/img/最小化.png";
                    zoomicon.alt = "shrink";
                    // $("body").parent().css("overflow-y","hidden");
                }
                if(this.message.thisSource=='4'&&this.infoShow&&!this.downloading) {
                    this.callFuncInThingJS('resize');
                }
            },
            closediv:function(){
                $('.kefuBtn').show();
                $('.qqBtn').show();
                $('.wxBtn').show();
                if($(".fullScreen").hasClass("tuichu")){
                    this.large();
                }
                this.infoShow = false;
                $('body').removeClass('overflowhide');
                this.iframeFlag = true;
            },
            moveSceneLeft:function(){
                leftchangeFlag = false;
                setTimeout(function(){
                    leftchangeFlag = true;
                },1000);
                var _this = this;
				var _list = _this.showList;
                var _index = _this.index - 1;
				if(_index < 0){
					_this.$layer.msg("已经是第一个了哦！");
                    $(".vl-notify.vl-notify-msg").css('left','45%');
                    $(".vl-notify.vl-notify-msg").css('index','10000');
				}else{
                    if(_list[_index].thisSource=='3'){
                        var sceneid = _list[_index].sceneId;
                        setTimeout(function(){
                            _this.sceneDetail(_list[_index],_index,true);
                        },500);
                    }else if(_list[_index].thisSource=='2'){
                        var sceneid = _list[_index].modelId;
                        _this.callFuncInThingJS("changeDirection",-1);
                        setTimeout(function(){
                            _this.modelDetail(_list[_index],_index,true);
                        },500);
                    }
				}
            },
            moveSceneRight:function(){
                rightchangeFlag = false;
                setTimeout(function(){
                    rightchangeFlag = true;
                },1000);
				var _this = this;
				var _list = _this.showList;
                var _index = _this.index + 1;
				if(_index >= _list.length){
                    if(_this.isLastPage){
                        _this.$layer.msg("已经是最后一个模型了哦！");
                        $(".vl-notify.vl-notify-msg").css('left','45%');
                        $(".vl-notify.vl-notify-msg").css('index','10000');
                    }else{
                        _this.loadMore();
                        setTimeout(function(){
                            if(_list[_index].thisSource=='3'){
                                var sceneid = _list[_index].sceneId;
                                setTimeout(function(){
                                    _this.sceneDetail(_list[_index],_index,true);
                                },500);
                            }else if(_list[_index].thisSource=='2'){
                                var sceneid = _list[_index].modelId;
                                _this.callFuncInThingJS("changeDirection",-1);
                                setTimeout(function(){
                                    _this.modelDetail(_list[_index],_index,true);
                                },500);
                            }
                        },300);
                    }
				}else{
                    if(_list[_index].thisSource=='3'){
                        var sceneid = _list[_index].sceneId;
                        setTimeout(function(){
                            _this.sceneDetail(_list[_index],_index,true);
                        },500);
                    }else if(_list[_index].thisSource=='2'){
                        var sceneid = _list[_index].modelId;
                        _this.callFuncInThingJS("changeDirection",-1);
                        setTimeout(function(){
                            _this.modelDetail(_list[_index],_index,true);
                        },500);
                    }
				}
            },
            moveModelLeft:function(){
                leftchangeFlag = false;
                setTimeout(function(){
                    leftchangeFlag = true;
                },1000);
				var _this = this;
				var _list = _this.showList;
                var _index = _this.index - 1;
				if(_index < 0){
					_this.$layer.msg("已经是第一个模型了哦！");
                    $(".vl-notify.vl-notify-msg").css('left','45%');
                    $(".vl-notify.vl-notify-msg").css('index','10000');
				}else{
                    if(_list[_index].isSketchfabModel) {
                        var _model=_list[_index];
                        _this.callFuncInThingJS("changeDirection",-1);
                        setTimeout(function(){
                            _this.modelDetail(_list[_index],_index,false,_model);
                        },500);
                    }else {
                         _this.callFuncInThingJS("changeDirection",-1);
                        setTimeout(function(){
                            _this.modelDetail(_list[_index],_index,false);
                        },500);
                    }
                    // if(_list[_index].isSketchfabModel) var _model=_list[_index];
                    // var sceneid = _list[_index].modelId;
                    // _this.callFuncInThingJS("changeDirection",-1);
                    // setTimeout(function(){
                    //     _this.modelDetail(_model,_index,false,_model);
                    // },500);
				}
			},
			moveModelRight:function(){
                rightchangeFlag = false;
                setTimeout(function(){
                    rightchangeFlag = true;
                },1000);
				var _this = this;
				var _list = _this.showList;
                var _index = _this.index + 1;
                if(_list[_index].isSketchfabModel) var _model=_list[_index];
				if(_index >= _list.length){
                    if(_this.isLastPage){
                        _this.$layer.msg("已经是最后一个模型了哦！");
                        $(".vl-notify.vl-notify-msg").css('left','45%');
                        $(".vl-notify.vl-notify-msg").css('index','10000');
                    }else{
                        _this.loadMore();
                        setTimeout(function(){
                            var sceneid = _list[_index].modelId;
                            _this.callFuncInThingJS("changeDirection",1);
                            setTimeout(function(){
                                _this.modelDetail(_list[_index],_index,true,false);
                            },500);
                        },300);
                    }
				}else{
                    var sceneid = _list[_index].modelId;
                    _this.callFuncInThingJS("changeDirection",1);
                    setTimeout(function(){
                        _this.modelDetail(_list[_index],_index,true,_model);
                    },500);
				}
            },
            callFuncInThingJS:function(funcName, data) {
                $('#myframeC').show();
                var iframe = $('#myframeC')[0];
                var message = {
                    'funcName': funcName,// 所要调用ThingJS页面里的函数名
                    'param': data
                }
                var size;
                if(this.message.width||this.message.length||this.message.height) {
                    size={
                        width:this.message.width,
                        length:this.message.length,
                        height:this.message.height
                    }
                    message.size=size;
                }
                if (iframe.contentWindow) iframe.contentWindow.postMessage(message, '*');
            },
            fullScreen: function(){
                var el = document.documentElement,
                    rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen,
                    wscript;

                if(typeof rfs != "undefined" && rfs) {
                    rfs.call(el);
                    return;
                }

                if(typeof window.ActiveXObject != "undefined") {
                    wscript = new ActiveXObject("WScript.Shell");
                    if(wscript) {
                        wscript.SendKeys("{F11}");
                    }
                }
            },
            exitFullScreen: function(){
                var el = document,
                        cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen,
                        wscript;
                if (typeof cfs != "undefined" && cfs) {
                    cfs.call(el);
                    return;
                }
                if (typeof window.ActiveXObject != "undefined") {
                    wscript = new ActiveXObject("WScript.Shell");
                    if (wscript != null) {
                        wscript.SendKeys("{F11}");
                    }
                }
            },
            //全屏触发
			large: function() {
                var _this = this;
                var parentF = '';
                var id = '';
                let zoomicon = document.getElementsByClassName('zoom_icon')[0];
                parentF = "#list_info";
                id = "#myframeC";
                if($(".fullScreen").hasClass("tuichu")){
                    _this.exitFullScreen();
                    $(parentF).removeClass("quanping");
                    $(id).removeClass("fullFrame");
                    $(".fullScreen").removeClass("tuichu");
                    // $("html").css("overflow-y","scroll");
                    $(".popContainer").show();
                    $(".fullScreenClose").hide();
                    if(zoomicon.alt == "shrink"){
                        $('.kefuBtn').show();
                        $('.qqBtn').show();
                        $('.wxBtn').show();
                        // $("body").parent().css("overflow-y","hidden");
                    }
                }else{
                    _this.fullScreen();
                    $(parentF).addClass("quanping");
                    $(id).addClass("fullFrame");
                    $(".fullScreen").addClass("tuichu");
                    // $("html").css("overflow-y","hidden");
                    $(".fullScreenClose").show();
                    $(".popContainer").hide();
                    $('.kefuBtn').hide();
                    $('.qqBtn').hide();
                    $('.wxBtn').hide();
                    // $("body").parent().css("overflow-y","hidden");
                    $('#scrollToTop').hide();
                }
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            // 下载模型
            downModel(uid,val) {
                var _this=this;
                let para={
                    modelid:uid,
                    access_token:_this.$parent.$parent.$refs.header.para.access_token,
                    refresh_token:_this.$parent.$parent.$refs.header.para.refresh_token,
                };
                _this.downSkechfabModel(para,uid);
            },
            // 下载
            downSkechfabModel(para,modelid,type){
                var _this=this;
                if(!para.modelid) para.modelid=modelid;
                $.ajax({
                    url: _this.DOWNMODELURL,
                    type:"post",
                    data:para,
                    dataType: "json",
                    success: function(data){
                        if(!data.state&&data.content=='用户令牌无效或丢失') {
                            if(!type) _this.refreshtoken(para.refresh_token,modelid);
                        } else if(!data.state) {
                            _this.$parent.$parent.$refs.header.alert(data.content);
                        }
                        return;
                    },
                    error:function(data) {
                        console.log(data);
                    }
                });
            },
            refreshtoken(refresh_token,modelid){
                var _this=this;
                _this.$reqs.post('/model/refreshtoken',{refresh_token:refresh_token}).then(res=>{
                    if(res.data.state&&res.data.content.code==200) {
                        sessionStorage.sketchUser=JSON.stringify(res.data.content);
                        _this.$parent.$parent.$refs.header.para=res.data.content;
                        _this.downSkechfabModel(res.data.content,modelid,'refresh_token');
                        return;
                    }
                    console.log(res.data)
                }).catch(err=>{
                    console.log(err);
                });
            },
            checkCampany:function(type,message){
                var _this = this;
                if($.cookie("openid")){
                    this.$reqs.get("/user/User_info?token="+$.cookie('token')).then(function(result) {
                        var infos =  result.data;
                        var openPage = '';
                        if(!infos.phoneVerify) openPage = 'phone';
                        if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';

                        if(openPage){//缺
                            _this.panelShow = true;
                            infos.type = type;
                            infos.msg = {title:type=="buyScene"?'购买成套模型':'购买模型',pages:openPage,toolInfo:message};
                            bus.$emit("openCampanyPanel",{infos:infos});
                        }else{//不缺
                            if(type == "buyScene"){
                                _this.buyscene(message);
                            }
                            if(type == "buyModel"){
                                _this.buymodel(message);
                            }
                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
                }else{
                    logoinForStore();
                }
            },
            showPanel:function(){
                if($.cookie('openid')){
                    this.panelShow = true;
                }
            },
            hidePanel:function(success) {
                console.log("asdfadfasdfasdf");
                var _this = this;
                this.panelShow = false;
                window.parent.postMessage('closePanel','*');
            },
        },
        beforeDestroy () {
            bus.$off("changeModelList");
            bus.$off("changeOtherModelList");
            bus.$off("addModelList");
            bus.$off("addOtherModelList");
            bus.$off("showModelNull");
            bus.$off("getchangeShowList_SDK");
        },
        mounted(){
            var _this = this;
            this.random=Math.ceil(Math.random()*100);
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryModelList(this.queryData);
            _this.auth_token = $.cookie('sketchToken');
            bus.$on("changeModelList", (data) => {
                this.showList = [];
                this.queryData = data;
                this.queryModelList(data);
            });
            bus.$on("showModelNull", (data) => {
                this.showList = [];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
                this.modelListLoading= false;
            });
            bus.$on("changeOtherModelList", (data) => {
                this.showList = [];
                this.queryOtherModelList(data);
            });
            bus.$on("addModelList", (data) => {
                this.queryData = data;
                this.queryModelList(data);
            });
            bus.$on("addOtherModelList", (data) => {
                this.queryData = data;
                this.queryOtherModelList(data);
            });
            bus.$on("buyScene", (data) => {
                data.infos.step = data.step;
                this.buyscene(data.infos);
            });
            bus.$on("buyModel", (data) => {
                data.infos.step = data.step;
                this.buymodel(data.infos);
            });
            bus.$on("getchangeShowList_SDK", (data) => {
                this.changeShowList_SDK = data
            });
            bus.$on("viewBulkModel",(data) => {
                this.sceneDetail(data,data.index,false,)
            })
            bus.$on("viewModel",(data) => {
                this.modelDetail(data,data.index,false,data)
            })
            // 接收ThingJS页面传送的数据
            window.addEventListener('message', function (e) {
                var data = e.data;
                var funcName = data.funcName;
                var param = data.param;
            });
            if(window.devicePixelRatio<'1.5' && window.devicePixelRatio >= '1.2'){
                $('.modelList_infoShow').addClass("trans_1");
            }else if(window.devicePixelRatio >= '1.5'){
                $('.modelList_infoShow').addClass("trans_2");
            }else{
                $('.modelList_infoShow').addClass("trans_3");
            }
            if(window.screen.width <= 1024){
                    document.getElementById("list_info").className = "modelList_infoShow_max";
                }
            window.onresize= function(){
                if(window.devicePixelRatio<'1.5' && window.devicePixelRatio >= '1.2'){
                    $('.modelList_infoShow').addClass("trans_1");
                }else if(window.devicePixelRatio >= '1.5'){
                    $('.modelList_infoShow').addClass("trans_2");
                }else{
                    $('.modelList_infoShow').addClass("trans_3");
                }
            };
            document.onkeydown = function(event){
                if(_this.infoShow){
                    if(event.keyCode == 65||event.keyCode == 37){
                        if(leftchangeFlag){
                            _this.moveModelLeft();
                        }else {
                            return;
                        }
                    }else if(event.keyCode == 68 || event.keyCode == 39){
                        if(rightchangeFlag){
                            _this.moveModelRight();
                        }else {
                            return;
                        }
                    }else{
                        return;
                    }
                }
            };
            $('#list_info').bind('mousewheel',function(event) {
                if (!event) event = window.event;
                this.scrollTop = this.scrollTop - (event.wheelDelta ? event.wheelDelta : -event.detail * 10);
                return false;
            });
            if (_this.isMobile()) {
                this.queryData.isAPP = true;
            } else {
                this.queryData.isAPP = false;
            }
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                        // return value.length>10 ? value.substring(0, 10)+"..." : value;
                    }
                }else{
                    return value;
                    // return value.length>10 ? value.substring(0, 10)+"..." : value;
                }
            },
            highLightKeyword:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                    }
                }else{
                    return value;
                }
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ModelList.vue